var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "button",
        {
          staticClass: "button order-now-button",
          class: _vm.buttonClasses,
          attrs: {
            disabled: _vm.currentLocation == null,
            "data-test-button-order": "",
          },
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.onWidgetSubmit.apply(null, arguments)
            },
          },
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(_vm.i18n.t("general:non_special_texts.order")) +
              "\n  "
          ),
        ]
      ),
      _vm._v(" "),
      _vm.currentLocation != null
        ? _c(
            "form",
            {
              ref: "orderWidgetFormRef",
              attrs: { method: "post", action: _vm.currentLocation.orderUrl },
            },
            [
              _c("input", {
                attrs: { type: "hidden", name: "data[Order][units]" },
                domProps: { value: _vm.units },
              }),
              _vm._v(" "),
              _c("input", {
                attrs: { type: "hidden", name: "data[Order][duration]" },
                domProps: { value: _vm.duration },
              }),
              _vm._v(" "),
              _c("input", {
                attrs: { type: "hidden", name: "data[Order][location]" },
                domProps: { value: _vm.currentLocation.key },
              }),
              _vm._v(" "),
              _vm._l(_vm.extras, function (extra) {
                return _c("input", {
                  key: extra.key,
                  attrs: {
                    type: "hidden",
                    name: _vm.getInputExtensionField(extra),
                  },
                  domProps: { value: extra.units },
                })
              }),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showRegionModal
        ? [
            _c(
              "div",
              { staticClass: "bs" },
              [
                _c("region-switcher-modal", {
                  on: {
                    "on-cancel-click": function ($event) {
                      _vm.showRegionModal = false
                    },
                    "on-accept-click": _vm.onRegionSwitcherConfirm,
                  },
                }),
              ],
              1
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }